import BannerProjects from '../../components/bannerProjects'
import BusinessOtimize from '../../components/businessOtimize'
import Discovery from '../../components/discovery'
import Metodologia from '../../components/metodologia'
import Rodape from '../../components/rodape'
import SolucoesTecnologicas from '../../components/solucoes-tecnologicas'
import SolucoesDesenvolvimento from '../../components/solucoesDesenvolvimento'
import TecnologiasUtilizadas from '../../components/tecnologiasUtilizadas'

export default function DevSolucoes() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/banner-development.png"
        bgMobile="../assets/dev-solucoes-mobile.png"
        title="/DESENVOLVIMENTO"
        titleBold="DE SOLUÇÕES"
        iconSrc="../assets/icone-projectiva-behub.png"
        iconAlt="Projectiva BeHub"
        iconText="be."
        iconTextBold="hub"
        description={
          <>
            Desenvolvemos soluções que{' '}
            <strong>
              transformam <br /> negócios
            </strong>
            .
          </>
        }
        footerText="VERTICAL PROJECTS | Development"
        buttonText="Quero me conectar"
        buttonColor="from-[#4B3BDB] to-[#A002CB]"
        brand="behub"
      />
      <SolucoesTecnologicas />
      <BusinessOtimize
        backgroundImage="../assets/background_ato.png"
        bgMobile="../assets/bg-purple.png"
        buttonText="Otimize seus negócios"
        buttonTextColor="from-[#A800E4] to-[#A800E4]"
        title={
          <>
            Nosso portfólio tem as{' '}
            <strong className="font-inter-bold">
              soluções ideais para sua empresa.
            </strong>
          </>
        }
      />
      <Metodologia />
      <Discovery />
      <SolucoesDesenvolvimento />
      <TecnologiasUtilizadas />
      <Rodape />
    </>
  )
}
